const course = {
    id: null,
    name: '',
    school: ''
}

export default course
